import { GetQueryVariables } from "api/apiFunctions";
import { getRequest } from "api/commonActions/get";
import { patchRequest } from "api/commonActions/update";
import { AxiosResponse } from "axios";
import { Requests } from "config/api";
import { QueryParamsProps } from "declarations/commonServices";
import {
  GetMoneyRequestProps,
  GetMoneyRequestReturnType,
  GetMoneyRequestsProps,
  GetMoneyRequestsReturnType,
  GetUserMoneyRequestsProps,
  GetUserMoneyRequestsReturnType,
  UpdateMoneyRequestProps,
  UpdateMoneyRequestReturnType,
} from "declarations/requestServices";

export const GetMoneyRequests = async ({
  limit,
  offset,
  setLoading,
}: GetMoneyRequestsProps): Promise<GetMoneyRequestsReturnType> => {
  let queryParams: QueryParamsProps = GetQueryVariables({
    limit,
    offset,
  });

  try {
    setLoading && setLoading(true);
    const response: AxiosResponse = await getRequest({
      route: Requests.get.getMoneyRequests,
      queryParams,
    });
    setLoading && setLoading(false);

    const status = response?.status;
    const requests = response.data?.requests;
    const message = response?.data?.msg;

    return {
      status: status,
      message: message,
      requests,
    };
  } catch (error) {
    setLoading && setLoading(false);
    throw error;
  }
};

export const GetUserMoneyRequests = async ({
  limit,
  offset,
  setLoading,
  user,
}: GetUserMoneyRequestsProps): Promise<GetUserMoneyRequestsReturnType> => {
  let queryParams: QueryParamsProps = GetQueryVariables({
    limit,
    offset,
  });

  try {
    setLoading && setLoading(true);
    const response: AxiosResponse = await getRequest({
      route: Requests.get.getUserMoneyRequests,
      queryParams,
      pathVariables: {
        id: user,
      },
    });
    setLoading && setLoading(false);

    const status = response?.status;
    const requests = response.data?.requests;
    const message = response?.data?.msg;

    return {
      status: status,
      message: message,
      requests,
    };
  } catch (error) {
    setLoading && setLoading(false);
    throw error;
  }
};

export const GetMoneyRequest = async ({
  setLoading,
  id,
}: GetMoneyRequestProps): Promise<GetMoneyRequestReturnType> => {
  try {
    setLoading && setLoading(true);
    const response: AxiosResponse = await getRequest({
      route: Requests.get.getClicks,
      pathVariables: {
        id,
      },
    });
    setLoading && setLoading(false);

    const status = response?.status;
    const request = response.data?.request;
    const message = response?.data?.msg;

    return {
      status: status,
      message: message,
      request,
    };
  } catch (error) {
    setLoading && setLoading(false);
    throw error;
  }
};

export const UpdateMoneyRequest = async ({
  setLoading,
  id,
  amount,
  requestStatus,
}: UpdateMoneyRequestProps): Promise<UpdateMoneyRequestReturnType> => {
  try {
    setLoading && setLoading(true);
    const response: AxiosResponse = await patchRequest({
      route: Requests.update.updateMoneyRequest,
      pathVariables: {
        id,
      },
      payload: {
        amount,
        status: requestStatus,
      },
    });
    setLoading && setLoading(false);

    const status = response?.status;
    const request = response.data?.request;
    const message = response?.data?.msg;

    return {
      status: status,
      message: message,
      request,
    };
  } catch (error) {
    setLoading && setLoading(false);
    throw error;
  }
};
